var version = {
    "name":      "dativery",
    "buildDateCode": "20260128-154929",
    "buildDate": "Wed Jan 28 2026 15:49:29 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260128-154929",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;